module.exports = __webpack_public_path__ + "static/media/art11.68095175.png";